<template>
  <div class="error-window">
    <BlinkNotAllowedWindow :error-obj="errorObj" />
    <div class="error-window-padding d-flex flex-column justify-center">
      <img v-if="image" :src="image" :alt="error.name" class="error-image">
      <Permission :error="errorObj" @check="check()" />
      <br>
      <div class="the-error text-center grey--text text--darken-1 body-2">
        {{ $t('errorCode') }}:
        <strong>{{ errorObj.name }}: {{ error }}</strong>
      </div>
    </div>
  </div>
</template>

<script>
import Permission from './Permission.vue';
import noCameraImage from '../../assets/img/no-camera.svg';
import brokenCameraImage from '../../assets/img/broken-camera.svg';
import BlinkNotAllowedWindow from './BlinkNotAllowedWindow.vue';

export default {
  name: 'RequestPermissionsError',
  components: { BlinkNotAllowedWindow, Permission },
  props: {
    error: {
      required: true,
    },
    errorObj: {
      required: true,
    },
  },
  computed: {
    image() {
      return this.isCameraError
        ? noCameraImage : brokenCameraImage;
    },
    isCameraError() {
      return this.error.name === 'NotFoundError' || this.error.name === 'NotReadableError';
    },
  },
  methods: {
    check() {
      this.$emit('check');
    },
  },
};
</script>

<style lang="scss" scoped>
.error-window {
  position: relative;
  width: 100%;
  max-width: 41.875rem;
  background-color: #F6F6F6;
  border-radius: 0.5rem;
  margin: 0 auto 2.5rem;

  .error-window-padding {
    padding: 5rem 2rem 5rem;
  }

  .the-error {
    strong {
      display: block;
    }
  }

  .error-image {
    width: 3.625rem;
    margin: 0 auto 3rem;
  }
}
</style>

<i18n locale="en" lang="yaml">
errorCode: Error code
</i18n>

<i18n locale="ru" lang="yaml">
errorCode: Код ошибки
</i18n>
